var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"address"},[_c('span',{staticClass:"iconfont"},[_vm._v("")]),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.address || _vm.please))]),_c('span',{attrs:{"bold":"","primary":""}},[_vm._v(_vm._s(_vm.$t('googlemap.change')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }